import intl from 'react-intl-universal';

// ==================== 类型定义 ====================

export type TourPerspective = 'sales' | 'guide' | 'conversion' | 'expectation';

export interface TourStep {
  /** 唯一标识（如 "step-1"） */
  id: string;
  /** 对应 HTML 中的 section ID */
  sectionId: string;
  /** 图标名称 */
  icon: string;
  /** 简短标题（不超过 12 字） */
  title: string;
  /** 解说内容（50-100 字，支持 ==高亮== 语法） */
  description: string;
  /** 视角类型 */
  perspective: TourPerspective;
}

export interface TourData {
  steps: TourStep[];
  generatedAt: number;
  projectContext?: string;
}

export interface TourPromptCardProps {
  /** 是否正在加载导览数据 */
  loading?: boolean;
  /** 点击"一起看看你的新网站"按钮 */
  onStart: () => void;
  /** 点击关闭按钮 */
  onClose: () => void;
}

export interface TourOverlayProps {
  /** 导览数据 */
  tourData: TourData;
  /** 当前步骤索引 */
  currentStep: number;
  /** 标注数量 */
  annotationCount?: number;
  completeText?: string;
  variant?: 'default' | 'mobile-preview';
  /** 步骤变更 */
  onStepChange: (step: number) => void;
  /** 完成导览 */
  onComplete: () => void;
  /** 关闭导览 */
  onClose: () => void;
}

// ==================== 布局常量 ====================

/** 步骤序号间距 */
export const STEP_NUMBER_SPACING = 36;
/** 紧凑卡片高度 */
export const COMPACT_CARD_HEIGHT = 72;
/** 卡片间距 */
export const CARD_GAP = 12;
/** 活跃卡片高度 */
export const ACTIVE_CARD_HEIGHT = 160;
/** 内容区域最大高度 */
export const CONTENT_MAX_HEIGHT = 280;

// ==================== 视角标签 ====================

const PERSPECTIVE_I18N_KEYS: Record<TourPerspective, string> = {
  sales: 'tour.perspective.sales',
  guide: 'tour.perspective.guide',
  conversion: 'tour.perspective.conversion',
  expectation: 'tour.perspective.expectation',
};

export function getPerspectiveLabel(perspective: TourPerspective): string {
  return intl.get(PERSPECTIVE_I18N_KEYS[perspective]);
}

// ==================== localStorage 持久化 ====================

export const TOUR_COMPLETED_STORAGE_KEY = 'tourCompletedProjects';
export const TOUR_DATA_STORAGE_PREFIX = 'tourData:';
